import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import AppAnalytics from '../analytics/AppAnalytics';

@customElement('homepage-ctas')
export class HomepageCtas extends LitElement {
  @property({ type: String })
  location = 'hero_section';

  static styles = css`
    :host {
      display: block;
    }

    .cta-container {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      justify-content: center;
    }

    @media (min-width: 640px) {
      .cta-container {
        flex-direction: row;
      }
    }

    .cta-button {
      border: 2px solid transparent;
      background: linear-gradient(135deg, rgba(0, 212, 255, 0.1), rgba(168, 85, 247, 0.1)) padding-box,
                  linear-gradient(135deg, #00d4ff, #a855f7) border-box;
      color: #0a0f1b;
      padding: 1rem 2.5rem;
      border-radius: 0.5rem;
      font-family: 'JetBrains Mono', monospace;
      font-weight: bold;
      font-size: 1.125rem;
      cursor: pointer;
      transition: all 0.2s;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
    }

    .cta-button:hover {
      text-shadow: 0 0 5px currentColor, 0 0 10px currentColor, 0 0 15px currentColor;
      transform: scale(1.05);
    }

    .cta-primary {
      background-image: linear-gradient(to right, #0ea5e9, #00d4ff);
    }

    .cta-secondary {
      background-image: linear-gradient(to right, #a855f7, #ec4899);
    }

    .cta-bottom-primary {
      background-image: linear-gradient(to right, #00ff88, #0ea5e9);
      padding: 1.25rem 3rem;
      font-size: 1.25rem;
    }

    .cta-bottom-secondary {
      background: transparent;
      border: 2px solid #00d4ff;
      color: #00d4ff;
      padding: 1.25rem 3rem;
      font-size: 1.25rem;
    }

    .cta-bottom-secondary:hover {
      background: #00d4ff;
      color: #0a0f1b;
    }
  `;

  private handleTrainLoraClick() {
    AppAnalytics.getPlausible()?.trackEvent('cta_clicked', {
      props: {
        page: 'homepage',
        button: this.location === 'hero_section' ? 'start_training' : 'start_training_now',
        location: this.location
      }
    });

    if (this.location === 'hero_section') {
      window.location.href = '/tools/train-lora';
    } else {
      window.location.href = '/tools/train-lora';
    }
  }

  private handleGenerateImagesClick() {
    AppAnalytics.getPlausible()?.trackEvent('cta_clicked', {
      props: {
        page: 'homepage',
        button: 'generate_images',
        location: this.location
      }
    });

    window.location.href = '/tools/generate-images';
  }

  private handleLearnMoreClick() {
    AppAnalytics.getPlausible()?.trackEvent('cta_clicked', {
      props: {
        page: 'homepage',
        button: 'learn_more',
        location: this.location
      }
    });

    window.location.href = '/about';
  }

  render() {
    if (this.location === 'bottom_cta') {
      return html`
        <div class="cta-container">
          <button
            class="cta-button cta-bottom-primary"
            @click=${this.handleTrainLoraClick}>
            <span>🚀</span>START_TRAINING_NOW
          </button>
          <button
            class="cta-button cta-bottom-secondary"
            @click=${this.handleLearnMoreClick}>
            <span>📖</span>LEARN_MORE
          </button>
        </div>
      `;
    }

    return html`
      <div class="cta-container">
        <button
          class="cta-button cta-primary"
          @click=${this.handleTrainLoraClick}>
          <span>🚀</span>START_TRAINING
        </button>
        <button
          class="cta-button cta-secondary"
          @click=${this.handleGenerateImagesClick}>
          <span>🎨</span>GENERATE_IMAGES
        </button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'homepage-ctas': HomepageCtas;
  }
}